<template>
  <div class="EmployeeCard mb-24 text-left">
    <div class="pt-16">
      <div v-if="showImages" class="aspect-portrait relative mb-16">
        <nuxt-img
          v-if="blok.image?.filename"
          preset="standard"
          loading="lazy"
          sizes="sm:100vw desk:1260px"
          class="h-full w-full object-cover"
          :src="blok.image.filename"
          :alt="blok.image.alt ?? ''"
        />
        <img
          v-else
          src="/icons/no-image.svg"
          class="object-cover w-full h-full"
          alt="no image"
        >
        <div v-if="!blok.image?.filename" class="imageOverlay absolute top-0 left-0 w-full h-full pointer-events-none" />
      </div>
      <div class="type-tagline mb-8">{{ blok.title }}</div>
      <div class="type-headline-sm desk:type-headline-lg mb-6">{{ blok.name }}</div>
      <div class="type-tagline mb-8">{{ blok.location }}</div>
      <div class="flex flex-col gap-6 desk:flex-row desk:gap-16">
        <div
          v-if="blok.mail.trim() !== ''"
          class="btn--text mobOnly:text-12"
        >
          <a :href="`mailto:${blok.mail}`">{{ blok.mail.replace('@', '&#x200b;@') }}</a>
        </div>
        <div
          v-if="blok.phone.trim() !== ''"
          class="btn--text mobOnly:text-12"
        >
          <a :href="`tel:${blok.phone}`">{{ blok.phone }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { EmployeeCardProps } from '#constants/types/storyblok';

defineProps<{
  blok: EmployeeCardProps,
  showImages?: boolean,
}>();
</script>

<style scoped lang="postcss">
</style>
